import React from 'react';

const UserPoints = ({ points }) => (
  <div className="user-points">
    <h2>Total Points: {points}</h2>
  </div>
);

export default UserPoints;